export const apiKey = 'b6313ad2c8e610d52b6e8b4069e58a7dbe66dc97c44cb7e927a5b2e3591a3797dfc578d13bddd0dada0dff8bf26b8dde592e996851b6d9fdf102b80dd168a794';

export const baseURL = 'https://apitracking.luftdigital.com.br';
// export const baseURL = 'http://localhost:7231';

export const tracking_manager = {
  GET_CUSTOMER_USERS_LIST: '/customer/list',
  GET_CUSTOMER_COMPANIES_LIST: '/customer/',
  CREATE_CUSTOMER_USER: '/users/',
  UPDATE_CUSTOMER_USER: '/users/',
  UPDATE_CUSTOMER_TRACKING: '/company/tracking-customer/',
  RESEND_EMAIL: '/confirmation/resendEmail',
};

export const recipient_tracking = {
  GET_RECIPIENT_USERS_LIST: '/company/list/',
};
